export const columnsDataStudies = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "alumno",
    accessor: "alumno",
  },
  {
    Header: "Documento",
    accessor: "documento",
  },
  {
    Header: "Estudio",
    accessor: "estudio",
  },
  {
    Header: "Plan",
    accessor: "plan",
  },
  {
    Header: "Ciclo",
    accessor: "ciclo",
  },
  {
    Header: "Fecha de exámen",
    accessor: "examenDate",
  },
  {
    Header: "Fecha de inscripción",
    accessor: "inscriptionDate",
  },
];
